angular.module("khUtils").directive('khCard', function () {
	return {
		restrict: 'E',
		replace: true,
		templateUrl: '/static/assets/khapps2/base/khutils/partials/kh_card.html',
		link: function (scope, element, attrs, controllers) {
			scope.cards = scope[attrs["cards"]];
		}
	};
});